module.exports = __webpack_public_path__ + "img/colour-how-much-orange.836d8857.gif";